module['exports'] = [
  'امریکی گڑیال',
  'آسٹریلیائ تازہ پانی کا گڑیال',
  'نیل گڑیال',
  'مشرقی افریقی گڑیال',
  'نمکین پانی کا گڑیال',
  'گڑیال',
];
